import Grid from "@mui/material/Grid";
import type { SxProps, Theme } from "@mui/material/styles";
import type { ReactNode } from "react";
import { FORM_GRID_SPACING, FORM_GRID_SPACING_COMPACT } from "../../lib/ui/formLayout";

type Props = {
  children: ReactNode;
  spacing?: "default" | "compact";
  alignItems?: "flex-start" | "center" | "flex-end" | "stretch";
  sx?: SxProps<Theme>;
};

/**
 * Standard form grid.
 * Uses explicit row/column gaps (never collapse margin) so outlined labels
 * and borders cannot overlap neighbouring fields. Same-row fields stretch equally.
 */
export default function AppFormGrid({
  children,
  spacing = "default",
  alignItems = "stretch",
  sx,
}: Props) {
  const gap = spacing === "compact" ? FORM_GRID_SPACING_COMPACT : FORM_GRID_SPACING;

  return (
    <Grid
      container
      columnSpacing={gap}
      rowSpacing={gap}
      alignItems={alignItems}
      sx={[
        {
          width: "100%",
          // Keep Grid spacing math intact — do NOT zero out container margins.
          maxWidth: "100%",
          boxSizing: "border-box",
          // Ensure every direct column starts on the same left edge rhythm.
          "& > .MuiGrid-root": {
            boxSizing: "border-box",
            minWidth: 0,
          },
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {children}
    </Grid>
  );
}
